import { Check, CustomAvInput, CustomBootstrapTable, CustomSelect } from "components/Common"
import { checkAllowRole, getI18nextLng, getInvalidMessageI18n, indexCalculator } from "helpers/utilities"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import FilterForm from "./FilterForm"
//i18n
import { AvForm } from "availity-reactstrap-validation"
import { CustomTooltipButton } from "components/Common/Button"
import CustomButtonIcon from "components/Common/Button/CustomButtonIcon"
import IconStatus from "components/Common/IconStatus"
import { ModuleIds, TestProfileType, parameterCode, permissionType, statusTypes } from "constant"
import { withTranslation } from "react-i18next"
import ReactTooltip from "react-tooltip"
import FormSwitchForm from "components/Common/FormSwitchForm"
import { getCodesByParameterId } from "helpers/app-backend"
import ImportExportButton from "./ImportExportForm"

const RESOURCE = ModuleIds.Test
const ProfileTable = ({
    onSelect,
    onSelectAll,
    testProfiles,
    onSearch,
    onSort,
    onRefresh,
    onPageChange,
    paging,
    onSizePerPageChange,
    onSubmitFilter,
    onEdit,
    onDelete,
    onClone,
    loading,
    t,
    updatedTime,
    onAddTestList,
    onDisplayOrderChange,
    onAddProfileSend,
    onDeleteVendor,
    onInfoProfieleChange,
    userPermissions
}) => {
    const [checkRoleUpdate, setCheckRoleUpdate] = useState(false)
    const [isHasUpdate, setIsHasUpdate] = useState(false)
    const [sampleTypes, setSampleTypes] = useState([])
    const [data, setData] = useState([])
    const [model, setModel] = useState({
        search: "",
        type: [],
        isSystem: ""
    })
    useEffect(() => {
        let check = checkAllowRole({
            permission: permissionType.ProfileSendUpdate,
            userPermissions,
            permissions: [],
            resource: RESOURCE,
            exclusivePermissions: []
        })
        setCheckRoleUpdate(check)
        let check2 = checkAllowRole({
            permission: permissionType.U,
            userPermissions,
            permissions: [],
            resource: RESOURCE,
            exclusivePermissions: []
        })
        setIsHasUpdate(check2)
    }, [userPermissions])

    let lang = getI18nextLng()
    const fetchCodesSampleType = async () => {
        let query = { lang }
        let res = await getCodesByParameterId(parameterCode.SAMPLE_TYPES, query);
        res = res.filter(r => r.inUse)
        res?.map(_item => {
            _item.value = _item.code
            _item.label = _item.message
            return _item
        })
        setSampleTypes(res)
    }
    useEffect(() => {
        fetchCodesSampleType()
    }, [])
    const searchQuery = useSelector(state => state.testProfile.searchQuery)
    const onResetHandler = () => {
        const initModel = {
            ...model,
            search: "",
            type: [],
            sampleType: "",
            category: "",
            // status: ""
        }
        let x = document.getElementsByName("type")
        for (let i = 0; i < x.length; i++) {
            x[i].checked = false
        }
        setModel(initModel)
    }
    useEffect(() => {
        setModel(searchQuery)
    }, [searchQuery])

    useEffect(() => {
        setData(testProfiles)
    }, [testProfiles])

    const columns = [
        {
            dataField: "id",
            text: "#",
            style: { width: 50 },
            formatter: (cellContent, testProfile, index) => {
                return indexCalculator(paging.page, paging.size, index + 1)
            },
        },
        {
            dataField: "id",
            text: "#",
            hidden: true,
            formatter: (cellContent, testProfile, index) => {
                return cellContent
            },
        },
        // {
        //     dataField: "",
        //     text: "",
        //     formatter: (cellContent, user, index) => {
        //         return (
        //             <div className="d-flex toolbar button-items text-end">
        //                 <CustomButtonIcon
        //                     id={`test-list-${index}`}
        //                     color="btn btn-outline-success btn-soft-success"
        //                     data-tip
        //                     data-for={`test-list-${index}`}
        //                     onClick={() => { onAddTestList(user) }}>
        //                     <i className="bx bx-add-to-queue" />
        //                 </CustomButtonIcon>
        //                 <ReactTooltip place="top" id={`test-list-${index}`} effect="solid">
        //                     {t("testProfilePage:QuickAdd")}
        //                 </ReactTooltip>
        //             </div>)
        //     },
        // },
        {
            dataField: "code",
            text: t("common:Code"),
            sort: true,
            formatter: (cellContent) => {
                return <span style={{ fontWeight: 'bold' }}>{cellContent}</span>
            }
        },
        {
            dataField: "profileName",
            text: t("common:Name"),
            style: { width: '420px' },
            sort: true,
            formatter: (cellContent, testProfile, index) => {
                return <Link to={`/TestProfile/${testProfile.id}/view?tab=1`}>{testProfile.profileName}</Link>
            },
        },
        {
            dataField: "type",
            text: t("Profile Type"),
            sort: true,
            formatter: (cellContent, user, index) => {
                return (
                    <>
                        {TestProfileType[cellContent] === "Profile" && (
                            <div className="px-2 d-flex badge-profile">
                                <span>{t("testProfilePage:ProfileSingle")}</span>
                            </div>
                        )}
                        {TestProfileType[cellContent] === "Group" && (
                            <div className="px-2 d-flex badge-group">
                                <span>{t("testProfilePage:ProfileGroup")}</span>
                            </div>
                        )}
                    </>
                )
            },
        },
        {
            dataField: "category",
            text: t("common:Category"),
            sort: true,
            formatter: (cellContent, item, index) => {
                return item.categoryName
            },
        },
        // {
        //     dataField: "testCount",
        //     text: t("testProfilePage:TestCount"),
        //     sort: true,
        //     align: 'center',
        //     headerAlign: 'center',
        //     formatter: (cellContent) => {
        //         return <span className="badge badge-submitted">{cellContent}</span>
        //     }
        // },
        {
            dataField: "sampleTypeName",
            text: t("common:SampleType"),
            sort: true,
            style: { width: "140px" },
            align: 'center',
            headerAlign: 'center',
            formatter: (cellContent, item, index) => {
                return (<>
                    {isHasUpdate && item.type != 2 ?
                        <div
                            onClick={e => {
                                document.getElementById(`sampleTypeName-${index}`).style.display = ""
                                document.getElementById(`sampleTypeName-${index}`).focus()
                                document.getElementById(`sampleTypeName-text-${index}`).style.display = "none"
                            }}>
                            <a
                                href="javascript:void(0)"
                                id={`sampleTypeName-text-${index}`}
                            >{cellContent || '---'}</a>
                            <div id={`sampleTypeName-${index}`}
                                style={{ display: 'none' }}
                                onBlur={() => {
                                    document.getElementById(`sampleTypeName-${index}`).style.display = "none"
                                    document.getElementById(`sampleTypeName-text-${index}`).style.display = ""
                                }}
                            >
                                <AvForm>
                                    <CustomSelect
                                        isClearable={false}
                                        name="sampleTypeName"
                                        value={item.sampleType || ''}
                                        options={sampleTypes}
                                        onChange={(name, value) => {
                                            if (value[0] != item.sampleType) {
                                                item.sampleType = value[0]
                                                onInfoProfieleChange(item)
                                            }
                                            document.getElementById(`sampleTypeName-${index}`).style.display = "none"
                                            document.getElementById(`sampleTypeName-text-${index}`).style.display = ""
                                        }}
                                    />
                                </AvForm>
                            </div>
                        </div>
                        :
                        <span>{cellContent}</span>
                    }
                </>
                )
            },
        },
        {
            dataField: "displayOrder",
            text: t("Display Order"),
            sort: true,
            style: { maxWidth: "100px" },
            align: '-webkit-center',
            headerAlign: '-webkit-center',
            formatter: (cellContent, item, index) => {
                return (<>
                    {isHasUpdate ?
                        <div
                            onClick={e => {
                                document.getElementById(`displayOrder-${index}`).style.display = ""
                                document.getElementById(`displayOrder-${index}`).focus()
                                document.getElementById(`displayOrder-text-${index}`).style.display = "none"
                            }}>
                            <a
                                href="#"
                                id={`displayOrder-text-${index}`}
                            >{cellContent}</a>
                            <AvForm>
                                <CustomAvInput
                                    style={{ display: 'none' }}
                                    id={`displayOrder-${index}`}
                                    name={`displayOrder`}
                                    value={item.displayOrder || ''}
                                    type='number'
                                    min={0}
                                    validate={{
                                        pattern: { value: '^[0-9]+$', errorMessage: getInvalidMessageI18n(t, "Display Order") },
                                        required: { value: true, errorMessage: getInvalidMessageI18n(t, "Display Order") },
                                    }}
                                    onBlur={(e) => {
                                        const numberRegex = /^[0-9]+$/
                                        if (!!e.target.value && numberRegex.test(e.target.value)) {
                                            onDisplayOrderChange(item, Math.abs(parseInt(e.target.value, 10)))
                                            document.getElementById(`displayOrder-${index}`).style.display = "none"
                                            document.getElementById(`displayOrder-text-${index}`).style.display = ""
                                        }
                                    }}
                                />
                            </AvForm>
                        </div>
                        :
                        <span>{cellContent}</span>
                    }
                </>
                )
            },
        },
        {
            dataField: "vendorId",
            text: t("testProfilePage:Vendor Code"),
            formatter: (cellContent, test, index) => {
                return <AvForm>
                    {checkRoleUpdate == true ?
                        <FormSwitchForm
                            name="vendorCode"
                            label=''
                            value={!!cellContent}
                            disabled={!cellContent}
                            onChange={() => {
                                onDeleteVendor(test.id)
                            }}
                        />
                        :
                        <FormSwitchForm
                            name="vendorCode"
                            label=''
                            value={!!cellContent}
                            disabled={true}
                            onChange={() => {
                            }}
                        />}
                </AvForm>
            },
        },
        {
            dataField: "status",
            text: t("common:Status"),
            sort: true,
            align: 'center',
            headerAlign: 'center',
            formatter: (cellContent, user, index) => {
                return <IconStatus
                    isRound={true}
                    type={cellContent ? statusTypes.ACTIVE : statusTypes.INACTIVE}
                />
            },
        },
        {
            dataField: "action",
            text: "",
            isDummyField: true,
            // style: { width: 50 },
            formatter: (cellContent, param, index) => {
                return (
                    <div style={{ display: 'flex' }}>
                        <Check permission={permissionType.ProfileSendUpdate} resource={RESOURCE} >
                            <div className="d-flex toolbar button-items text-end" style={{ marginRight: '8px' }}>
                                <CustomButtonIcon
                                    id={`profile-send-${index}`}
                                    color="btn btn-outline-warning btn-soft-warning"
                                    disabled={param?.vendorId || TestProfileType[param.type] === 'Group'}
                                    data-tip
                                    data-for={`profile-send-${index}`}
                                    onClick={() => { onAddProfileSend(param) }}>
                                    <i className="mdi mdi-plus" />
                                </CustomButtonIcon>
                                <ReactTooltip place="top" id={`profile-send-${index}`} effect="solid">
                                    {t("profilePage:Add profile send")}
                                </ReactTooltip>
                            </div>
                        </Check>
                        <Check permission={permissionType.U} resource={RESOURCE} >
                            <div className="d-flex toolbar button-items text-end" style={{ marginRight: '8px' }}>
                                <CustomButtonIcon
                                    id={`test-list-${index}`}
                                    color="btn btn-outline-success btn-soft-success"
                                    data-tip
                                    data-for={`test-list-${index}`}
                                    onClick={() => { onAddTestList(param) }}>
                                    <i className="bx bx-add-to-queue" />
                                </CustomButtonIcon>
                                <ReactTooltip place="top" id={`test-list-${index}`} effect="solid">
                                    {t("testProfilePage:QuickAdd")}
                                </ReactTooltip>
                            </div>
                        </Check>
                        <CustomTooltipButton
                            index={index}
                            component={param}
                            onClone={onClone}
                            onEdit={onEdit}
                            onDelete={onDelete}
                            resource={RESOURCE}
                            t={t}
                        />
                    </div>
                )
            },
        },
    ]
    return (
        <CustomBootstrapTable
            columns={columns}
            search
            isSelected
            data={data}
            paging={paging}
            onSelect={onSelect}
            onSelectAll={onSelectAll}
            onSearch={onSearch}
            onSort={onSort}
            onRefresh={onRefresh}
            filterForm={() => <FilterForm model={model} />}
            onReset={onResetHandler}
            onPageChange={onPageChange}
            onSizePerPageChange={onSizePerPageChange}
            onSubmitFilter={onSubmitFilter}
            searchText={model.search}
            loading={loading}
            updatedTime={updatedTime}
            resource={RESOURCE}
            isImportExportButton={true}
            importExportForm={() => <ImportExportButton model={model} />}
        />
    )
}
export default withTranslation(["testProfilePage", "common", "profilePage"])(ProfileTable)